import { render, staticRenderFns } from "./SliderToggle.vue?vue&type=template&id=07b2101a&"
import script from "./SliderToggle.vue?vue&type=script&lang=js&"
export * from "./SliderToggle.vue?vue&type=script&lang=js&"
import style0 from "./SliderToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports